import ApiParty from '@/api/ApiParty'

export default {
    loadPartys (isPast, page, size) {
        return ApiParty.loadPartys(isPast, page, size)
    },
}
